import React, { Component } from "react";
import { Router, Route, Switch } from "react-router-dom";
import history from "./shared/history";
import Home from "./makingsense/Home";
import Section from "./components/Section";
import ViewPage from "./shared/page/components/ViewPage/ViewPage";
import { HelpPage } from "./shared/help/components/HelpPage";
import { AboutPage } from "./components/about/AboutPage"
import ListView from "./components/ListView";
import CERLPDA from "./cerl/components/CERLPDA";
import { parse } from "query-string";
import NotFound from "./components/liminal/NotFound";
import { SearcherContext } from "./shared/search/components/SearcherContext";
import { descriptionRenderers } from "./shared/object/rendering";
import { personDisplayName } from "./shared/facet/components/PersonFacet";

descriptionRenderers["person"] = personDisplayName;

class App extends Component {
  static contextType = SearcherContext;
  state = {};

  componentDidCatch() {
    // Display fallback UI
    this.setState({ hasError: true });
    setTimeout(() => this.setState({ hasError: undefined }), 10000);
  }

  updateSearchTerm(params) {
    const { searchTerm } = params;
    this.setState({ searchTerm });
    return searchTerm;
  }

  render() {
    // see if there is any credentials passed in as a token
    const parsed = parse(window.location.search);
    if (parsed.token && parsed.name && parsed.exp && parsed.uid) {
      this.context.addCredentials({
        token: parsed.token,
        name: parsed.name,
        exp: parsed.exp,
        uid: parsed.uid
      });
    }
    if (parsed.token && parsed.token === "skip") {
      this.context.removeCredentials();
      this.context.saveSettings();
    }

    return (
      <Router history={history}>
        <div>
          {this.state.__hasError && (
            <div className="app__error">
              Oops, an error has occurred in the application. Sorry about that.
              <br />
              Can you please send us some feedback using the ribbon in the
              top-right hand corner and let us know what you were doing when the
              error occurred?
            </div>
          )}
          <Switch>
            <Route
              exact
              path="/"
              render={({ match, history }) => (
                <div>
                  <Home match={match} history={history} search={this.context} />
                </div>
              )}
            />
            <Route
              exact
              path={`${process.env.REACT_APP_URL_PATH}/`}
              render={({ match, history }) => (
                <div>
                  <Home match={match} history={history} search={this.context} />
                </div>
              )}
            />
            <Route
              path={`${process.env.REACT_APP_URL_PATH}/section/:section`}
              render={({ match, history }) => (
                <div>
                  <Section
                    match={match}
                    history={history}
                    search={this.context}
                  />
                </div>
              )}
            />
            <Route
              path={`${process.env.REACT_APP_URL_PATH}/view/:uid/:section`}
              render={({ match, history, location }) => (
                <div>
                  <ViewPage
                    match={match}
                    history={history}
                    location={location}
                    section={match.params.section}
                    search={this.context}
                  />
                </div>
              )}
            />
            <Route
              path={`${process.env.REACT_APP_URL_PATH}/lists`}
              render={({ match, history, location }) => (
                <div>
                  <ListView
                    search={this.context}
                    match={match}
                    history={history}
                    location={location}
                  />
                </div>
              )}
            />
            <Route
              path={`${process.env.REACT_APP_URL_PATH}/help/:page`}
              render={({ match, history, location }) => (
                <HelpPage
                  match={match}
                  history={history}
                  location={location}
                  search={this.context}
                  page={match.params.page}
                />
              )}
            />
            <Route
              path={`${process.env.REACT_APP_URL_PATH}/about/:page`}
              render={({ match, history, location }) => (
                <AboutPage
                  match={match}
                  history={history}
                  location={location}
                  search={this.context}
                  page={match.params.page}
                />
              )}
            />
            <Route
              path={`${process.env.REACT_APP_URL_PATH}/about`}
              render={({ match, history, location }) => (
                <AboutPage
                  match={match}
                  history={history}
                  location={location}
                  search={this.context}
                  page={'main'}
                />
              )}
            />
            <Route
              path={`${process.env.REACT_APP_URL_PATH}/cerl/pda/edit/:uid`}
              render={({ match, history, location }) => (
                <div>
                  <CERLPDA
                    search={this.context}
                    match={match}
                    history={history}
                    location={location}
                    uid={match.params.uid}
                  />
                </div>
              )}
            />
            <Route
              path={`${process.env.REACT_APP_URL_PATH}/cerl/pda/`}
              render={({ match, history, location }) => (
                <div>
                  <CERLPDA
                    search={this.context}
                    match={match}
                    history={history}
                    location={location}
                  />
                </div>
              )}
            />
            <Route
              render={({ history }) => (
                <NotFound search={this.context} history={history} />
              )}
            />
          </Switch>
        </div>
      </Router>
    );
  }
}

export default App;
